import { MInput } from "components/forms";
import { MnemoLoading, Title } from "components/misc";
import { MTable } from "components/table";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Button, Container } from "design-react-kit";
import { BoxDanger } from "components/misc";
import { LESSON_TYPE, ROUTES } from "const";
import { adminService, dateHelper, networkErrorHelper } from "libs";
import i18n from "app/i18n";
import { getCurrentCompany, getCurrentRegion } from "store/actions";

class DashboardStewardLessonGrid extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      payload: [],
      payloadToRender: [],
      payloadToRenderFiltered: [],
      searchFilter: {
        searchAA: "",
      },
      rndKey: 0,
      searchFieldCC: [
        {
          id: "searchFrom",
          field: "searchFrom",
          label: "dal",
          type: "date",
          className: "form-control",
          onChange: (_elm, value) => {
            this.onSearchForm(value);
          },
          value: "",
        },
        {
          id: "searchTo",
          field: "searchTo",
          label: "al",
          type: "date",
          className: "form-control",
          onChange: (_elm, value) => {
            this.onSearchForm(value);
          },
          value: "",
        },
      ],
    };
  } //constructor

  //--- ---
  tableConfig = {
    columns: [
      {
        id: "id", // identifier of columns
        Header: "Column 0",
        isVisible: false, // IMPORTANT: hidden columns
        accessor: "id", // accessor is the "key" in the data
      },
      {
        id: "date",
        Header: "Data",
        accessor: (row) => {
          return row.date ? dateHelper.toITDateUTC(row.date) : "";
        },
      },
      {
        id: "hourStart",
        Header: "Ora inizio",
        accessor: (row) => {
          return row.hourStart
            ? row.hourStart.substring(0, row.hourStart.length - 3)
            : "";
        },
      },
      {
        id: "teacher",
        Header: "Docente",
        accessor: "teacher",
      },
      {
        id: "competitionClass",
        Header: "Classe di concorso",
        accessor: (row) => {
          return row?.competitionClass?.length > 10
            ? row.competitionClass.replaceAll(",", ", ")
            : row.competitionClass;
        },
      },
      {
        id: "courseCode",
        Header: "Corsi",
        accessor: "courseCode",
      },
      {
        id: "classGroup",
        Header: "Aula",
        accessor: "classGroup",
      },
    ],
    actions: [
      {
        id: "qrcodeScan",
        accessor: "id",
        label: "Scansione QrCode",
        icon: "it-camera",
        className: "MTable-actions",
        onClick: (e, value) => {
          window.open(
            ROUTES.STEWARD_VERIFY_IDENTITY +
              "/" +
              value +
              "/" +
              this.props.lessonType,
            "_self",
          );
        },
      },
      {
        id: "qrAttendance",
        accessor: "id",
        label: "Elenco Partecipanti",
        icon: "it-user",
        className: "MTable-actions",
        onClick: (e, value) => {
          window.open(
            ROUTES.STEWARD_VERIFY_ATTENDANCE +
              "/" +
              value +
              "/" +
              this.props.lessonType,
            "_self",
          );
        },
      },
    ],
  };

  componentDidMount() {
    this.loadRemoteSchedule(this.props.lessonType);
  }

  loadRemoteSchedule(lessonType) {
    this.setState({ loading: true });
    const searchFilter = {
      archivied: false,
      mode: "presenza",
      region: getCurrentRegion(),
      company: getCurrentCompany(),
    };

    let api = null;
    if (lessonType === LESSON_TYPE.LESSON_ONSITE) {
      api = adminService.loadLessonOnSiteSchedule({ searchFilter });
    }
    if (lessonType === LESSON_TYPE.LESSON_TRAINING) {
      api = adminService.loadTrainingSchedule({ searchFilter });
    }

    if (api === null) {
      return true;
    }

    api
      .then(({ data }) => {
        let objRet = {};
        if (lessonType === LESSON_TYPE.LESSON_ONSITE) {
          objRet = data.payload.lessonOnSiteSchedule || [];
        }
        if (lessonType === LESSON_TYPE.LESSON_TRAINING) {
          objRet = (data.payload.trainingSchedule || []).filter(
            (item) => item.mode === "presenza",
          );
        }

        let items = [];
        Object.entries(objRet).forEach(([key, val]) => {
          items.push(val);
        });
        //--- end: prepare reactTable ---

        // show only the items to render by current date and later
        const currentDate = new Date();
        const itemsFromNow = items.filter(
          (item) => new Date(item.date) >= currentDate,
        );

        this.setState({
          loading: false,
          payload: items,
          payloadToRender: itemsFromNow,
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        } else {
          this.setState({
            payload: [],
            payloadToRender: [],
            rndKey: Math.floor(Math.random() * 1000 + 1),
          });
        }
      });
  }

  onSearchForm = () => {
    const searchFrom = document.getElementById("searchFrom").value.trim();
    const searchTo = document.getElementById("searchTo").value.trim();

    let searchFieldCCUpdated = [...this.state.searchFieldCC];
    searchFieldCCUpdated[0].value = searchFrom;
    searchFieldCCUpdated[1].value = searchTo;

    this.setState({
      ...this.state,
      searchFieldCC: searchFieldCCUpdated,
    });

    const searchFromDate = searchFrom
      ? new Date(searchFrom + "T00:00:00")
      : null;
    const searchToDate = searchTo ? new Date(searchTo + "T23:59:59") : null;

    const results = this.state.payload.filter((item) => {
      let match = true;

      const itemDate = new Date(item.date);

      if (searchFromDate && !isNaN(searchFromDate.getTime())) {
        match = match && itemDate >= searchFromDate;
      }

      if (searchToDate && !isNaN(searchToDate.getTime())) {
        match = match && itemDate <= searchToDate;
      }

      return match;
    });

    this.setState({
      payloadToRender: results,
      rndKey: Math.floor(Math.random() * 1000 + 1),
    });
  }; //onSearchForm

  onShowFromNow = () => {
    const currentDate = new Date();
    const itemsFromNow = this.state.payload.filter(
      (item) => new Date(item.date) >= currentDate,
    );

    this.setState({
      payloadToRender: itemsFromNow,
      rndKey: Math.floor(Math.random() * 1000 + 1),
    });
  }; //onShowFromNow

  //--- ---

  render() {
    const { loading } = this.state;

    return (
      <>
        <div className="container mt-3 mb-4">
          <section className="my-4">
            <Container>
              <Title>{i18n.t(this.props.lessonType)}</Title>
            </Container>
          </section>
          <section className="m-0">
            <div className="form-row mb-4">
              <div className="col-md-3">
                <MInput {...this.state.searchFieldCC[0]} className="mb-0" />
              </div>
              <div className="col-md-3">
                <MInput {...this.state.searchFieldCC[1]} className="mb-0" />
              </div>
              <div className="col-md-6 text-right">
                <Button
                        color="primary bg-dark"                        
                  onClick={() => {
                    this.onShowFromNow();
                  }}
                >
                  <span className="d-button-label">LEZIONI DI OGGI</span>
                </Button>
              </div>
            </div>
          </section>

          <hr />

          <section className="my-4">
            {loading ? (
              <MnemoLoading></MnemoLoading>
            ) : (
              <Container>
                <MTable
                  key={this.state.rndKey}
                  tableData={this.state.payloadToRender}
                  tableConfig={this.tableConfig}
                />
              </Container>
            )}

            {this.state.payloadToRender.length === 0 && (
              <BoxDanger key="nrp-1" className="my-3">
                Ricerca non valida.
                <div className="small text-info">Nessun dato disponibile.</div>
              </BoxDanger>
            )}
          </section>
        </div>
      </>
    );
  }
}

export default withRouter(DashboardStewardLessonGrid);
